import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';
import ngSanitize from 'angular-sanitize';

import HomeController from './HomeController';

import popupPreferences from '../../directives/popupPreferences';
import matchesMessage from '../../directives/matchesMessage';
import photoGallery from '../../directives/photoGallery';
import userNotifications from '../../directives/userNotifications';

import panel from '../../services';

export default angular.module('app.home', [uirouter, panel, popupPreferences, matchesMessage, photoGallery, userNotifications, ngSanitize])
    .config(routing)
    .controller('HomeController', HomeController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/home/index.js